module.exports = __webpack_public_path__ + "static/Banner-22-7e9866b3e2b4cb325274648006532bce.png";